import ActiveTabLink from './ActiveTabLink';

export default ActiveTabLink;
